define('Store.QuantityPricing.Model', [
    'Backbone.CachedModel',
    'Utils'
], function StoreItemQuantityPricingModel(
    CachedModel,
    Utils
) {
    'use strict';

    return CachedModel.extend({
        urlRoot: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/Store.Item.QuantityPricing.Service.ss'))
    });
});
